import matchEntities from '../src/shared/entityHelpers';

const featureFlags = {
  enablePublicCitiesPages: () => {
    return matchEntities(['NETHERLANDS']);
  },
  enabledAccreditations: () => {
    return matchEntities(['UK']);
  },
  // Consent withdrawal is only offered on the UK site for now; the other
  // entities keep the first-visit banner as their only entry point.
  enabledCookieSettings: () => {
    return matchEntities(['UK']);
  },
};
export default featureFlags;
